import { styled } from "styled-components";


export const SectionDevice = styled.div`
    display:flex;
    flex-direction:row;
    margin-top: 10px;
    gap:10px;
  
  }
`;